<script lang="ts" setup>
const scriptTag = ref('script')

const config = useRuntimeConfig()

const cookieBotId = config.public.cookieBotId as string
</script>

<template>
  <div>
    <h2>{{ $t('cookiePolicy') }}</h2>
    <ClientOnly>
      <component
        :is="scriptTag"
        id="CookieDeclaration"
        :src="`https://consent.cookiebot.com/${cookieBotId}/cd.js`"
        type="text/javascript"
        async
        defer
      />
    </ClientOnly>
  </div>
</template>
